import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import download from "../../assets/download (1).jpg";
import back from "../../assets/back.jpg";
import { useNavigate } from "react-router-dom";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { getAllJob } from "../../Api/commonApi";
import { loader } from "../../store/utilities";
import { useMediaQuery } from "react-responsive";
import JobApplicationForm from "../JobListing/JobApplicationForm";

const JobSlider = () => {
  const isPic = useMediaQuery({ query: "(max-width: 768px)" });

  let settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: isPic ? 1 : 3,
    slidesToScroll: isPic ? 1 : 3,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <Slider {...settings} className={style.sliderContainer}>
      <div
        className={`border rounded-4 mr-5 ${style.card_container} slide-item`}
      >
        <div className={`${style.sub_container_style} `}>
          <div className="">
            <img
              src={download}
              className="object-cover"
              alt="Job"
              width={100}
              height={100}
            />
          </div>
          <div className="">
            <div className={`${style.job_role_heading_slider}`}>IT Support</div>
            <div className={`${style.jobs_style_button}`}>1 Job</div>
          </div>
        </div>
      </div>

      <div className={`border rounded-3 ${style.card_container} slide-item`}>
        <div className={`${style.sub_container_style}`}>
          <div className="">
            <img
              src={download}
              className="w-full h-full object-cover"
              alt="Job"
              width={100}
              height={100}
            />
          </div>
          <div className="">
            <div className={`${style.job_role_heading_slider}`}>Chef</div>
            <div className={`${style.jobs_style_button}`}>28 Jobs</div>
          </div>
        </div>
      </div>

      <div className={`border rounded-3 ${style.card_container} slide-item`}>
        <div className={`${style.sub_container_style}`}>
          <div className="">
            <img
              src={download}
              className="w-full h-full object-cover"
              alt="Job"
              width={100}
              height={100}
            />
          </div>
          <div className="">
            <div className={`${style.job_role_heading_slider}`}>
              Admin Assistant
            </div>
            <div className={`${style.jobs_style_button}`}>65 Jobs</div>
          </div>
        </div>
      </div>

      <div className={` border rounded-3 ${style.card_container} slide-item`}>
        <div className={`${style.sub_container_style}`}>
          <div className="">
            <img
              src={download}
              className=""
              alt="Job"
              width={100}
              height={100}
            />
          </div>
          <div className="">
            <div className={`${style.job_role_heading_slider}`}>Driver</div>
            <div className={`${style.jobs_style_button}`}>2 Jobs</div>
          </div>
        </div>
      </div>
    </Slider>
  );
};

const JobPortal = () => {
  const [getAllData, setGetAllData] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const handleOpenForm = (jobTitle) => {
    setSelectedJob(jobTitle);
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
  }
  const getAllJobDataFunction = async () => {
    loader.start();
    try {
      let response = await getAllJob().then((res) => {
        return res.data.data;
      });
      console.log(response);
      setGetAllData(response);
    } catch (error) {
      console.log(error);
    } finally {
      loader.stop();
    }
  };

  useEffect(() => {
    getAllJobDataFunction();
  }, []);
  let navigate = useNavigate();
  const createExcerpt = (html, length = 400) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.body.textContent?.substring(0, length) + "...";
  };
  return (
    <div className={`p-4${style.card_container1}`}>
      <div className={style.back}>
        <div className="p-5">
          <div className="text-center mb-4 ">
            <h1 className="text-2xl font-bold text-white">
              Find The Best Job For Your Future
            </h1>
            <p className="text-gray-600 text-white">
              A mutually beneficial platform for both Jobseekers and Employers
            </p>
          </div>

          <div className="text-center mb-4">
            <input
              type="search"
              placeholder="Search Job"
              className="border p-2 m-2 rounded"
            />
            <input
              type="search"
              placeholder="Search Location"
              className="border p-2 m-2 rounded"
            />
            <button
              className="btn btn-light px-4 py-2 rounded mb-1"
              onClick={() => navigate("/jobPortal/joblist")}
            >
              Search
            </button>
          </div>
          <div className="d-flex gap-5 justify-content-center m-5 p-5">
            <JobSlider />
          </div>

          <div
            className="container"
            style={{
              width: "100%",
              background:
                "linear-gradient(to right,rgb(208, 222, 253),rgb(167, 199, 242))",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <div className="row text-center no-gutters">
              <div className=" col-lg-6 col-md-6">
                <h5 className="mt-3">Available Positions</h5>
                <h2 className="counter mb-0">830</h2>
              </div>
              <div className=" col-lg-6 col-md-6">
                <h5 className="mt-3">Employers Hiring</h5>
                <h2 className="counter mb-0">803</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center">
        <div classname="background-color: #f0f3fa;">
          <div className="p-5">
            <div className="section-title center-block text-center">
              <h1>Latest Jobs</h1>
            </div>

            <div className="panel panel-primary">
              <div className="tabs-menu p-4">
                <button
                  type="button"
                  class="btn btn-outline-primary mx-2 px-3 rounded-pill"
                >
                  All
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary mx-2 px-3 rounded-pill"
                >
                  Full-time
                </button>
                <button
                  type="button"
                  class="btn btn-outline-success mx-2 px-3 rounded-pill"
                >
                  Part-Time
                </button>
                <button
                  type="button"
                  class="btn btn-outline-danger mx-2 px-3 rounded-pill"
                >
                  Internship
                </button>
                <button
                  type="button"
                  class="btn btn-outline-warning mx-2 px-3 rounded-pill"
                >
                  Temporary
                </button>
                <button
                  type="button"
                  class="btn btn-outline-info mx-2 px-3 rounded-pill"
                >
                  Permanent
                </button>
              </div>
            </div>

            {/* cards */}

            <div className={`${style.grid_container_explore_job}`}>
              {getAllData.map((item, index) => {
                return (
                  <>
                    <div className={`${style.card_shadow} p-4 pointer`}>
                      <div className={`text-center ${style.job_role_heading}`}>
                        {item?.job_role}
                      </div>
                      <div
                        className={`mt-2 ${style.job_description_style} `}
                        dangerouslySetInnerHTML={{
                          __html: createExcerpt(item?.description, 400),
                        }}
                        onClick={() => navigate(`/jobPortal/jobDetails/${item?._id}`)}
                      />
                      <hr />
                      <div className="d-flex justify-content-between px-4">
                        <div>{item?.vacancy}</div>
                        <div>{"Full-Time"}</div>
                      </div>
                      <hr />
                      <div
                        className={`mt-2 text-center pointer ${style.company_name_style}`}
                        onClick={() => navigate(`/jobPortal/jobDetails/${item?._id}`)}
                      >
                        {item?.company_name}
                      </div>
                      <div className="mt-3">
                        <div className="btn btn-primary mt-auto" onClick={() => handleOpenForm(item.title)}>Apply</div>
                      </div>
                    </div>
                  </>
                );
              })}

<JobApplicationForm open={openForm} handleClose={handleCloseForm} jobTitle={selectedJob} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobPortal;
